<div class="notification-dropdown">
  <!-- Notification Bell Button with Badge -->
  <div class="notification-trigger-container">
    <button
      type="button"
      class="notification-trigger"
      (click)="toggleDropdown()"
      [class.has-notifications]="hasUnreadNotifications()"
    >
      <i class="pi pi-bell"></i>
      <span class="notification-badge" *ngIf="hasUnreadNotifications()">{{ unreadCount }}</span>
    </button>
  </div>

  <!-- Custom Notification Dropdown -->
  <div class="custom-notification-dropdown" [class.show]="isDropdownOpen">
    <div class="dropdown-header">
      <h3>Notifications</h3>
      <span class="notification-count">{{ notifications.length }} total</span>
    </div>

    <div class="notifications-list" *ngIf="hasNotifications(); else noNotifications">
      <div 
        *ngFor="let notification of notifications" 
        class="notification-item"
        [class]="'notification-item-' + notification.type"
        [class.unread]="!notification.isRead"
        (click)="onNotificationClick(notification)"
      >
        <div class="notification-icon">
          <i [class]="getNotificationIcon(notification.type)"></i>
        </div>
        <div class="notification-content">
          <div class="notification-title">
            {{ notification.title }}
            <span class="unread-badge" *ngIf="!notification.isRead">NEW</span>
          </div>
          <div class="notification-message" [innerHTML]="formatMessage(notification.message)"></div>
          <div class="notification-time">{{ formatTimestamp(notification.timestamp) }}</div>
        </div>
      </div>
    </div>

    <ng-template #noNotifications>
      <div class="no-notifications">
        <i class="pi pi-bell"></i>
        <p>No notifications</p>
      </div>
    </ng-template>

    <!-- Action Buttons -->
    <div class="dropdown-actions" *ngIf="hasNotifications()">
      <div class="action-separator" *ngIf="hasUnreadNotifications()"></div>
      
      <button 
        class="action-button refresh"
        (click)="refreshNotifications()"
      >
        <i class="pi pi-refresh"></i>
        Refresh
      </button>
      
      <button 
        *ngIf="hasUnreadNotifications()"
        class="action-button mark-all-read"
        (click)="markAllAsRead()"
      >
        <i class="pi pi-check"></i>
        Mark all as read
      </button>
      
      <button 
        class="action-button clear-all"
        (click)="clearAllNotifications()"
      >
        <i class="pi pi-trash"></i>
        Clear all
      </button>
    </div>
  </div>

  <!-- Backdrop to close dropdown when clicking outside -->
  <div class="dropdown-backdrop" *ngIf="isDropdownOpen" (click)="closeDropdown()"></div>
</div>
